import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '../store/state';
import { AppDispatch } from '../store/store';
import {
  selectCurrentTrack,
  selectKeywordsLevels,
  selectKeywordState,
  selectUserKeywordsInCurrentTrack,
} from '../store/selectors';
import KeywordPicker from '../components/KeywordPicker/KeywordPicker';
import { postUserKeywordsDTO } from '../store/user/types';
import userSlice from '../store/user/slice';
import { OpenSnackBarDTO } from '../store/error/types';
import errorSlice from '../store/error/slice';
import styled from 'styled-components';

interface Props {
  keywordState: KeywordState;
  userKeywords: number[];
  postUserKeywordsAction: (data: postUserKeywordsDTO) => void;
  openSnackBarAction: (data: OpenSnackBarDTO) => void;
  keywordsLevels: KeywordsLevels;
}

const KeywordsPage: React.FC<Props> = ({
  keywordState,
  userKeywords,
  postUserKeywordsAction,
  openSnackBarAction,
  keywordsLevels,
}) => {
  return (
    <StyledKeywordPickerWrapper className="h-full">
      <KeywordPicker
        selectedIds={userKeywords}
        keywordById={keywordState.keywordById}
        keywordTree={keywordState.keywordTree}
        maxAllowed={5}
        onSelected={(selectedIds) => postUserKeywordsAction({ keyword_ids: selectedIds })}
        openSnackBarAction={openSnackBarAction}
        keywordsLevels={keywordsLevels}
      />
    </StyledKeywordPickerWrapper>
  );
};

const mapStateToProps = (state: AppState) => ({
  userKeywords: selectUserKeywordsInCurrentTrack(state),
  track: selectCurrentTrack(state),
  keywordState: selectKeywordState(state),
  keywordsLevels: selectKeywordsLevels(state),
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  postUserKeywordsAction: (data: postUserKeywordsDTO) => dispatch(userSlice.actions['POST:KEYWORDS'](data)),
  openSnackBarAction: (data: OpenSnackBarDTO) => dispatch(errorSlice.actions['OPEN:SNACKBAR'](data)),
});

const StyledKeywordPickerWrapper = styled.div`
  .keywordsFooterButtons {
    background-color: rgb(237, 243, 255);
    max-width: 56rem;
  }
`;

export default connect(mapStateToProps, mapDispatchToProps)(KeywordsPage);
